export default __webpack_public_path__ + "static/media/04.d8110c26.jpg";